import * as moment from 'moment';

export class AccountingPeriodBlock {
    _id: string;
    competence: number;
    competenceYear: number;
    observation: string;
    created: Date;
    user: {name: string, username: string};
    type: number;

    loadFromServer(r: any) {
        if (r._id)
            this._id = r._id;

        if (r.user)
            this.user = r.user;

        if (r.observation)
            this.observation = r.observation;

        if (r.created)
            this.created = r.created;

        if (r.competence)
            this.competence = r.competence;

        if(r.competenceYear)
            this.competenceYear = r.competenceYear;

        if(r.type)
            this.type = r.type;
    }

    convertToDate(month: number, year: number): Date {
        let newDate = moment(`${month}-${year}`, "MM-YYYY").toDate();
        return newDate;
    }

    convertStringToDate(date: string): Date {
        let newDate = moment(date, "YYYY-MM").toDate();
        return newDate;
    }

    splitCompetence(): any {
        let newDate = moment(`${this.competence}/${this.competenceYear}`, "MM/YYYY");

        let year = newDate.year();

        let correctMonth = newDate.month() + 1;
        let month = correctMonth.toLocaleString('en-US', {minimumIntegerDigits: 2});

        return { year, month };
    }
}



// WEBPACK FOOTER //
// ./src/app/models/AccountingPeriodBlock.model.ts